import React, { useEffect, useState } from "react";
import testimonialImage from "../../assets/images/testimonial-bg.jpg";
import home1 from "../../assets/images/spagheti1.png";
import sphageti from "../../assets/images/spagheti1.png"
import { useTranslation } from "react-i18next";
import ContactUs from "../../components/Sections/ContactUs";
import OurStory from "../../components/Sections/OurStory/OurStory";
import UpcomingEvents from "../../components/Sections/UpcomingEvents/UpcomingEvents";
import WhyChooseUs from "../../components/Sections/WhyChooseUs/WhyChooseUs";

const About = () => {
  const [t, i18n] = useTranslation("global");

  const [showBackToTop, setShowBackToTop] = useState(false);

  // Add an event listener to handle scroll events
  const handleScroll = () => {
    // Show the "Back to Top" button when the user scrolls beyond a certain point
    if (window.scrollY > 100) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  };

  // Add the event listener when the component mounts
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Function to scroll back to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Add smooth scrolling behavior
    });
  };

  return (
    <div>
      {/* [PRELOADER] */}

      <div className="preload" data-preaload>
        <div className="circle"></div>
        <p className="text">LE MARLY</p>
      </div>

      <main>
        <article>
          {/* HERO */}

          <section
            className="hero-about text-center"
            aria-label="home"
            id="home"
          >
            <ul className="hero-about-slider" data-hero-slider>
              {/* LIST ONE */}
              <li className="slider-item active" data-hero-slider-item>
                <div className="slider-bg">
                  <img
                    src={sphageti}
                    width="1880"
                    height="950"
                    alt=""
                    className="img-cover"
                  />
                </div>

                <p className="label-2 section-subtitle slider-reveal">
                  {t("about.abt")}
                </p>

                <p className="body-2 hero-about-text slider-reveal">
                  {t("about.about-l")}
                </p>
              </li>
              {/* LIST TWO */}
              <li className="slider-item" data-hero-slider-item>
                <div className="slider-bg">
                  <img
                    src={home1}
                    width="1880"
                    height="950"
                    alt=""
                    className="img-cover"
                  />
                </div>

                <p className="label-2 section-subtitle slider-reveal">
                  {t("about.abt")}
                </p>

                <p className="body-2 hero-about-text slider-reveal">
                  {t("about.about-l")}
                </p>
              </li>
              {/* LIST THREE */}

              <li className="slider-item" data-hero-slider-item>
                <div className="slider-bg">
                  <img
                    src={home1}
                    width="1880"
                    height="950"
                    alt=""
                    className="img-cover"
                  />
                </div>

                <p className="label-2 section-subtitle slider-reveal">
                  {t("about.abt")}
                </p>

                <p className="body-2 hero-about-text slider-reveal">
                  {t("about.about-l")}
                </p>
              </li>
            </ul>

            <button
              className="slider-btn prev"
              aria-label="slide to previous"
              data-prev-btn
            >
              <ion-icon name="chevron-back"></ion-icon>
            </button>

            <button
              className="slider-btn next"
              aria-label="slide to next"
              data-next-btn
            >
              <ion-icon name="chevron-forward"></ion-icon>
            </button>
          </section>

          {/* ABOUT */}

          <section
            className="section about text-center"
            aria-labelledby="about-label"
            id="about"
          >
            <OurStory />
          </section>

          {/* TESTIMONIALS */}

          <section
            className="section testi text-center has-bg-image"
            style={{
              backgroundImage: `url(${testimonialImage})`,
              backgroundColor: "black", // Fallback color
            }}
            aria-label="testimonials"
          >
            <div className="container">
              <div className="quote">”</div>

              <p className="headline-2 testi-text">{t("dish.test")}</p>

              <div className="wrapper">
                <div className="separator"></div>
                <div className="separator"></div>
                <div className="separator"></div>
              </div>

              <div className="profile">
                <p className="label-2 profile-name">{t("dish.frm")}</p>
              </div>
            </div>
          </section>

          {/* RESERVATION */}

          <section className="reservation">
            <ContactUs />
          </section>

          {/* FEATURES */}

          <section
            className="section features text-center"
            aria-label="features"
          >
            <WhyChooseUs />
          </section>

          {/* EVENT */}

          <section className="section event bg-black-10" aria-label="event">
            {/*<UpcomingEvents />*/}
          </section>
        </article>
      </main>

      {/* BACK TO TOP */}

      <button
        href=""
        className="back-top-btn active"
        aria-label="back to top"
        onClick={scrollToTop}
        data-back-top-btn
      >
        <ion-icon name="chevron-up" aria-hidden="true"></ion-icon>
      </button>
    </div>
  );
};

export default About;
